import { Component, computed, effect, inject, OnDestroy, OnInit, Renderer2, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './core/components/header/header';
import { Footer } from './core/components/footer/footer';
import { HeaderMobile } from './core/components/header-mobile/header-mobile';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FooterMobile } from "./core/components/footer-mobile/footer-mobile";
import { Store } from '@ngrx/store';
import { selectAlert, selectModalConfirm, selectSpinner } from './state/settings/setting.selectors';
import { ModalConfirm } from "./shared/components/modal-confirm";
import { ModalConfirmProps } from './shared/models/modal-confirm';
import { Alert } from './shared/components/alert';
import { AlertProps } from './shared/models/alert-props';
import { SettingActions } from './state/settings/setting.actions';

export const MOBILE_WIDTH_BK = 900;

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    Header,
    Footer,
    HeaderMobile,
    CommonModule,
    FooterMobile,
    ModalConfirm,
    Alert
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit, OnDestroy {
  protected readonly title = signal('sanzioni-frontend');
  private breakpointSubscription: Subscription = new Subscription;
  protected isVisible = signal<boolean>(false);
  protected readonly isMobileSidebarOpen = signal<boolean>(false);

  private store = inject(Store);
  private renderer = inject(Renderer2)
  private breakpointObserver = inject(BreakpointObserver);
  spinner = this.store.selectSignal<boolean>(selectSpinner);
  modalConfirm = this.store.selectSignal<ModalConfirmProps | null>(selectModalConfirm);
  alert = this.store.selectSignal<AlertProps | null>(selectAlert);
  timer: any;

  constructor() {
    effect(() => {
      if (this.alert()) {
        this.timer = setTimeout(() => {
          this.store.dispatch(SettingActions.closeAlert());
        }, this.alert()?.duration);
      }
      if (this.spinner()) {
        this.renderer.addClass(document.body, 'overflow-y-hidden');
      } else {
        this.renderer.removeClass(document.body, 'overflow-y-hidden');
      }
    });
  }

  ngOnInit() {
    this.breakpointSubscription = this.breakpointObserver.observe(`(max-width: 56rem)`)
      .subscribe(state => {
        this.isVisible.set(state.matches);
      });
  }

  sidebarOpen(event: boolean) {
    this.isMobileSidebarOpen.set(event);
  }

  ngOnDestroy(): void {
    this.breakpointSubscription.unsubscribe();
    clearTimeout(this.timer);
  }


}
